export const DARK_BLUE = "#070c32";
export const VIOLET = "#7777ff";
export const WHITE = "#ffffff";
export const GREY_DARK = "#999dac";
export const GREY_LIGHT = "#E7E7E7";
export const RED = "#F00044";
export const GREEN = "#04902b";
export const BLACK = "#000";
